<div class="flex  border-b border-dashed" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="grow font-bold px-3 py-2" cdkDragHandle>
    {{ title }}
    <div class="handle"></div>
  </div>
  <span *ngIf="closeButton" class="grow-0 flex items-center justify-center border-l bg-gray-100 cursor-pointer hover:text-red-500 px-3 py-2" (click)="closeOpenModal()">
    <mat-icon svgIcon="close" color="black" style="height: 15px; width: 15px"></mat-icon>
  </span>
</div>
